import React from "react";
import { Align } from "../../horizontal/types/Navigation";
import { NavContainer } from "./NavStyles";

type NavProps = {
  align?: Align;
};

const Nav: React.FC<React.PropsWithChildren<NavProps>> = ({ align = "start", children }) => {
  return <NavContainer align={align}>{children}</NavContainer>;
};

export default Nav;
